import {ColorHueKey, ColorTintKey} from './types'

/**
 * Color hue keys.
 * @public
 */
export const COLOR_HUES: ColorHueKey[] = [
  'gray',
  'blue',
  'purple',
  'magenta',
  'red',
  'orange',
  'yellow',
  'green',
  'cyan',
]

/**
 * Color tint keys.
 * @public
 */
export const COLOR_TINTS: ColorTintKey[] = [
  '50',
  '100',
  '200',
  '300',
  '400',
  '500',
  '600',
  '700',
  '800',
  '900',
  '950',
]
